import React from "react";
import styled from "styled-components";
import { media, spacing, typography } from "../../styles/designSystem";

const Card = styled.div`
    background-color: ${({ theme }) => theme.cardBackground || theme.background};
    border: 1px solid ${({ theme }) => theme.borderLight};
    box-shadow: inset 0 0 40px rgba(0, 0, 0, 0.5);
    padding: ${spacing[800]};
    max-width: 260px;
    line-height: 1.6;
    margin-top: 3rem;
    color: ${({ theme }) => theme.labelText || theme.text};

    ${media.lg} {
        max-width: 100%;
    }
`;

const Section = styled.div`
    margin-bottom: ${spacing[700]};

    &:last-child {
        margin-bottom: 0;
    }
`;

const Label = styled.h4`
    font-family: ${typography.fontFamily.display};
    font-size: ${typography.fontSize[200]};
    text-transform: uppercase;
    letter-spacing: ${typography.letterSpacing.widest};
    margin: 0 0 ${spacing[300]} 0;
    padding-bottom: ${spacing[200]};
    border-bottom: 1px solid ${({ theme }) => theme.borderMedium};
    display: block;
    color: ${({ theme }) => theme.primary};
`;

const Content = styled.p`
    font-size: ${typography.fontSize[300]};
    line-height: ${typography.lineHeight.relaxed};
    margin: ${spacing[400]} 0 ${spacing[200]} 0;
    color: ${({ theme }) => theme.text};

    &:last-child {
        margin-bottom: 0;
    }
`;

const InfoCard = ({ dates, roles = [], tools = [] }) => {
    return (
        <Card>
            <Section>
                <Label>Dates</Label>
                <Content>{dates}</Content>
            </Section>

            <Section>
                <Label>Role</Label>
                {roles.map((role, i) => (
                    <Content key={i}>{role}</Content>
                ))}
            </Section>

            <Section>
                <Label>Tools</Label>
                <Content>{tools.join(", ")}</Content>
            </Section>
        </Card>
    );
};

export default InfoCard;
